import {ActionTypes as AuthentificationActionTypes} from './modules/authentification/actions/types'
import {MutationTypes as AuthentificationMutationTypes} from './modules/authentification/mutations/types'
import {MutationTypes as CompaniesMutationTypes} from './modules/companies/mutations/types'
import {ActionTypes as CompaniesActionTypes} from './modules/companies/actions/types'
import {MutationTypes as EmployeesMutationTypes} from './modules/employees/mutations/types'
import {ActionTypes as EmployeesActionTypes} from './modules/employees/actions/types'
import {MutationTypes as CategoriesMutationTypes} from './modules/categories/mutations/types'
import {ActionTypes as CategoriesActionTypes} from './modules/categories/actions/types'
import {MutationTypes as CriterionsMutationTypes} from './modules/criterions/mutations/types'
import {ActionTypes as CriterionsActionTypes} from './modules/criterions/actions/types'
import {MutationTypes as SubscriptionMutationTypes} from './modules/subscriptions/mutations/types'
import {ActionTypes as SubscriptionActionTypes} from './modules/subscriptions/actions/types'
import {AuthentificationStore} from './modules/authentification/types'
import {CompaniesStore} from './modules/companies/types'
import {EmployeeesStore} from './modules/employees/types'
import {CategoriesStore} from './modules/categories/types'
import {CriterionsStore} from './modules/criterions/types'
import {SubscriptionStore} from './modules/subscriptions/types'
 
export const StoreActionTypes = {
    ...AuthentificationActionTypes,
    ...CompaniesActionTypes,
    ...EmployeesActionTypes,
    ...CategoriesActionTypes,
    ...CriterionsActionTypes,
    ...SubscriptionActionTypes
}

export const StoreMutationTypes = {
    ...AuthentificationMutationTypes,
    ...CompaniesMutationTypes,
    ...EmployeesMutationTypes,
    ...CategoriesMutationTypes,
    ...CriterionsMutationTypes,
    ...SubscriptionMutationTypes
}

type StoreModules = {
    authentification: AuthentificationStore;
    companies: CompaniesStore;
    employees: EmployeeesStore;
    categories: CategoriesStore;
    criterions: CriterionsStore;
    subscription: SubscriptionStore;
}

export type Store = AuthentificationStore<Pick<StoreModules, "authentification">> 
    & CompaniesStore<Pick<StoreModules, 'companies'>>
    & EmployeeesStore<Pick<StoreModules, 'employees'>>
    & CategoriesStore<Pick<StoreModules, 'categories'>>
    & CriterionsStore<Pick<StoreModules, 'criterions'>>
    & SubscriptionStore<Pick<StoreModules, 'subscription'>>